document.addEventListener("DOMContentLoaded", function () {
  var openNavButton = document.querySelector(".open-nav");
  var closeNavButton = document.querySelector(".close-nav");
  var navOverlay = document.querySelector(".nav-overlay");

  // Handle Navigation Open
  openNavButton.addEventListener("click", function () {
    navOverlay.style.visibility = "visible";
    navOverlay.style.opacity = "1";

    document.body.style.overflow = "hidden";
  }); 


  // Handle Navigation Close
  closeNavButton.addEventListener("click", function () {
    navOverlay.style.opacity = "0";
    navOverlay.style.visibility = "hidden";

    document.body.style.overflow;
  });
  navOverlay.addEventListener("click", function () {
    navOverlay.style.opacity = "0";
    navOverlay.style.visibility = "hidden";

    document.body.style.overflow;
  });
});
